import { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../../utils/theme/godzilla_light"
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../constants"
import { Trans } from "react-i18next";
import { CommonCustomTooltip } from "../../../components/dialog/CommonCustomTolltip";

const styles = {
    boxWrapper: {
        pt: "65px",
        pb: "71px",
        display: "flex",
        alignItems: 'center',
        justifyContent: "center"
    },
    descriptionStyle: {
        ...theme.typography.poppinsBodyLight,
        fontSize:"18px",
        px: "3rem",
        mt: "24px"
    },
    sectionCard: {
        backgroundColor: "#F8F8F8",
        py: "62px",
        px: "27px",
        mt: "24px",
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)',
    },
    sectionCardTooltipBoxSx: {
        position: "absolute",
        transform: "translate(-50%, -50%)",
        width: "24px",
        height: "24px",
        cursor: "pointer",
        zIndex: 2,
        backgroundColor: "transparent",
    },
    footerText: {
        ...theme.typography.components.sectionDescription,
        fontSize: "16px",
        px: "3rem",
        mt: "24px",
        fontStyle: "italic"
    },
    extraText: {
        ...theme.typography.components.sectionDescription,
        fontSize: "14px",
        fontStyle: "italic",
        px: "3rem",
        mt: "24px"
    }
}
type TooltipMarker = {
    id: number;
    top: string;
    left: string;
    text: string;
  };
interface ISectionProps {
    title?: string;
    description?: string;
    sectionTitle?: string;
    sectionImgUrl?: any;
    sectionWrapperSx?: any;
    descriptionSx?: any;
    sectionCardSx?: any;
    customElement?: JSX.Element;
    footerText?: string;
    imageStyle?: any;
    containerBoxSx?: any;
    subTitleSx?: any;
    extraContent?: string;
    extraContentSx?: any;
    tooltipMarkers?: TooltipMarker[];
}
const PageSection = (props: ISectionProps) => {
    const { title, description, sectionTitle, sectionImgUrl, sectionWrapperSx, descriptionSx, sectionCardSx, customElement = null, footerText, imageStyle, containerBoxSx, subTitleSx, extraContent, extraContentSx, tooltipMarkers } = props;
    const [tooltipId, setTooltipId] = useState<number | null>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const isMobileX = useMediaQuery(theme.breakpoints.down(600))

    return (
        <Box sx={{ ...styles.boxWrapper, ...sectionWrapperSx }}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%" sx={{ ...containerBoxSx }}>
                {title ?
                    <Typography sx={{ ...theme.typography.components.sectionTitle }}>
                        <Trans
                            i18nKey={title}
                            components={{ br: <br />, sup: <sup /> }} />
                    </Typography> : null}
                {description ?
                    <Typography sx={{ ...styles.descriptionStyle, ...descriptionSx }}>
                        <Trans
                            i18nKey={description}
                            components={{ br: <br />, sup: <sup /> }} />
                    </Typography>
                    : null
                }
                {extraContent ?
                    <Typography sx={{ ...styles.extraText, ...extraContentSx }}>
                        <Trans
                            i18nKey={extraContent}
                            components={{ br: <br />, sup: <sup /> }} />
                    </Typography>
                    : null
                }
               {sectionTitle ? 
                <Typography sx={{ ...theme.typography.poppinsBodyRegular,fontSize:"18px", fontWeight: 500, mt: "24px", ...subTitleSx }}>
                    <Trans
                        i18nKey={sectionTitle}
                        components={{ br: <br />, sup: <sup /> }} />
                </Typography>
                :null
               }
                {sectionImgUrl ? (
                    <Box sx={{ ...styles.sectionCard, ...sectionCardSx, position: "relative" }} className={isMobileX ? 'customScrollContainer' : "none"}>
                        <img src={sectionImgUrl} alt="section-img" style={{ width: '100%', ...imageStyle }} /> 
                        {tooltipMarkers?.map((marker) => (
                            <Box
                                key={marker.id}
                                onClick={(event) => {
                                setTooltipId(marker.id);
                                setAnchorEl(event.currentTarget);
                                }}
                                sx={{...styles.sectionCardTooltipBoxSx, top: marker.top, left: marker.left}}
                            />
                            ))}
                            <CommonCustomTooltip
                                open={Boolean(anchorEl && tooltipId !== null)}
                                anchorEl={anchorEl}
                                maxWidth={265}
                                onClose={() => {
                                    setTooltipId(null);
                                    setAnchorEl(null);
                                }}
                                content={
                                    tooltipMarkers?.find((m) => m.id === tooltipId)?.text || ''
                                }
                            />
                            </Box>
                    ) : null}
                {customElement}
                {footerText ?
                    <Typography sx={styles.footerText}>
                        <Trans
                            i18nKey={footerText}
                            components={{ br: <br />, sup: <sup /> }} />
                    </Typography>
                    : null}
            </Box>
        </Box>
    )
}

export default PageSection